/**
 * @fileoverview Fruits theme - match fruit emojis.
 */

import { ThemeOptions } from '../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../Labels.js';

/**
 * Fruits theme with colorful fruit emojis.
 */
export class FruitsTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'fruits',
            'Fruits',
            allLabels.fruits,
            { numPairs: 8, isPremium: false, hasMovement: false, ...options }
        );
    }
}
